import { Component, HostBinding, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '../../access/shared/authorization/authorization.service';
import { Permissions } from '../../access/shared/authorization/permissions';

@Component({
  selector: 'app-lecture-cab',
  templateUrl: './lecture-cab.component.html',
  styleUrls: ['./lecture-cab.component.scss']
})
export class LectureCabComponent implements OnInit {
  @HostBinding('class.clamp') clamp = true;

  title: string;
  constructor(private authService: AuthorizationService, private router: Router) { }

  ngOnInit() {
    this.selectTitle();
  }

  onChange($text) {
    this.title = $text;
  }

  selectTitle() {
    this.title = this.router.url.includes('historique') ? "Détail des lectures" : this.title = this.router.url.includes('import') ? "Import" : "Bilan des lectures"
  }

  canImport() {
    return this.authService.hasPermission(Permissions.ROLE_LECTURECAB_IMPORT);
  }

}
